export default __webpack_public_path__ + "static/media/frechen_light.0e8ae587.png";